module.exports = __webpack_public_path__ + "img/mount6.0673819f.jpg";